import { render, staticRenderFns } from "./IconSvgHome.vue?vue&type=template&id=16c500f1&scoped=true&"
import script from "./IconSvgHome.vue?vue&type=script&lang=js&"
export * from "./IconSvgHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c500f1",
  null
  
)

export default component.exports